import { redirect } from '@hooks'
import { createFileRoute } from '@tanstack/react-router'

const ApiKey = redirect('/integration/apikey')

export const Route = createFileRoute('/apikey/')({
  component: ApiKey,
})
